import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { Observable } from 'rxjs'
import { MexusViewMode } from '../mexus-view-mode'
import { ViewModeContextService } from '../view-mode-context.service'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-view-mode-context-menu',
  templateUrl: './view-mode-context-menu.component.html',
  styleUrls: ['./view-mode-context-menu.component.scss'],
  imports: [MatButton, MatIcon, AsyncPipe, ElderTranslatePipe],
})
export class ViewModeContextMenuComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly ViewMode = MexusViewMode
  private viewModeContextService = inject(ViewModeContextService)

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  public get activeViewMode$(): Observable<MexusViewMode> {
    return this.viewModeContextService.viewMode$
  }

  public get activeViewMode(): MexusViewMode {
    return this.viewModeContextService.viewMode
  }

  public set activeViewMode(viewMode: MexusViewMode) {
    if (viewMode) {
      this.viewModeContextService.setViewMode(viewMode)
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onViewModeToggle(): void {
    switch (this.activeViewMode) {
      case MexusViewMode.LIVE:
        this.activeViewMode = MexusViewMode.PREVIEW
        break
      case MexusViewMode.PREVIEW:
        this.activeViewMode = MexusViewMode.LIVE
        break
    }
  }
}
